<template>
  <multi-select
    label="Team: "
    :options="options"
    :values="selectedValue"
    :hide-border="true"
    text-between-pills="OR"
    menu-alignment="right"
    @change="onChange"
    placeholder="Choose teams"
  >
    <template v-slot:listItem="option">
      <div class="d-flex align-items-baseline align-items-center text-truncate">
        <span class="text-truncate" :title="option.option.label">{{ option.option.label }}</span>
        <span
          class="pl-1 text-small text-secondary"
          v-if="option.option.isOrgLike && option.option.id !== subOrgId"
          >(Child Org)</span
        >
      </div>
    </template>
  </multi-select>
</template>

<script>
import MultiSelect from '@/components/form/MultiSelect.vue'

/**
 * This filter lets selection of a team/sub-org to perform filter on team field
 */
export default {
  name: 'TeamSelectionField',
  props: ['options', 'value', 'subOrgId'],
  components: { MultiSelect },
  data() {
    return {
      isEmptied: false
    }
  },
  computed: {
    selectedValue() {
      return this.isEmptied ? [] : this.value
    }
  },
  methods: {
    onChange(event) {
      this.isEmptied = event.length === 0
      if (event.length > 0) event = event.filter(x => x.id !== -1) // remove "All Owners" from field if some value is selected
      this.$emit('change', event.map(team => team.id).join(','))
    }
  },
  mounted() {},
  watch: {
    value(currentValue) {
      if (this.isEmptied && currentValue?.filter(x => x.id !== -1).length > 0) {
        this.isEmptied = false // this is to handle reset filter case
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
